<div>
  <app-line-chart
    *ngIf="valgtAnlegg && selectedDate && dataSets"
    chartId="myHourchart-line"
    [dataSets]="dataSets"
    [labels]="labels"
    [title]="title"
    [tooltipCallbacks]="tooltipCallbacks"
    [xUnit]="'hour'"
    [yUnit]="'kr'"
    [showYTitle]="true"
  >
  </app-line-chart>
</div>

<ng-template #loadingTemplate>
  <div class="loadingContainer" *ngIf="showLoader">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
